import React from 'react'


// export function SearchBar(props) {
  class SearchBar extends React.Component {
    constructor(props) {
      super(props);
    }
    render(){
      const { filterList, editorClick, className, value } = this.props

      return (
        <div className={`searchbox ${className || ''}`.trim()}>

          {/* <div style={{marginLeft:'2%'}}>
            <FontAwesomeIcon icon={faSearch} color='white' size="md"/>
          </div> */}

          <div style={{width: '100%'}}>
            <input type="text" name="filter" className="searchButton"
              defaultValue={value || ''}
              onChange={filterList} onFocus={editorClick}
              placeholder=''
            />
          </div>

          {/* <div style={{width: "5%"}}>
            <a 
              className="hint-tip pull-right" 
              style={{paddingRight: '1em'}} 
              onClick={() => this.setState({ searchHint: !this.state.searchHint })}
            >
              <FontAwesomeIcon icon={faInfoCircle} color='white' size="sm"/>
              {
                this.state.searchHint &&
                <div className="hint-tip-text" id="name-hint" style={{marginTop: '1.5em', marginLeft: '-20em' }}>
                  <span>
                      To refine your search, use the comma and the space characters to separate search terms.  
                      Example: "u15, camp, co-ed "
                  </span>
                </div>
              }
            </a>
          </div> */}
          
        </div>
      )
    }
}

export default SearchBar;
